export class MDITRBodyModel {
    constructor(
        public isDocReadable: string,
        public isAssessmentYearCorrect: string,
        public isIncomeCorrect: string,
    ) { }
}